import { JSX } from 'react'

import { IconProps } from '../../icon'

const Pause: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M32.2667 8H30.8444C29.62 8.00468 28.447 8.49317 27.5812 9.35899C26.7154 10.2248 26.2269 11.3978 26.2222 12.6222V35.3778C26.2269 36.6022 26.7154 37.7752 27.5812 38.641C28.447 39.5068 29.62 39.9953 30.8444 40H32.2667C33.4911 39.9953 34.6641 39.5068 35.5299 38.641C36.3957 37.7752 36.8842 36.6022 36.8889 35.3778V12.6222C36.8842 11.3978 36.3957 10.2248 35.5299 9.35899C34.6641 8.49317 33.4911 8.00468 32.2667 8ZM33.3333 35.3778C33.3333 35.5179 33.3057 35.6566 33.2521 35.786C33.1985 35.9154 33.12 36.033 33.0209 36.132C32.9219 36.2311 32.8043 36.3096 32.6749 36.3633C32.5454 36.4169 32.4067 36.4444 32.2667 36.4444H30.8444C30.5615 36.4444 30.2902 36.3321 30.0902 36.132C29.8902 35.932 29.7778 35.6607 29.7778 35.3778V12.6222C29.7778 12.3393 29.8902 12.068 30.0902 11.868C30.2902 11.6679 30.5615 11.5556 30.8444 11.5556H32.2667C32.4067 11.5556 32.5454 11.5831 32.6749 11.6368C32.8043 11.6904 32.9219 11.7689 33.0209 11.868C33.12 11.967 33.1985 12.0846 33.2521 12.214C33.3057 12.3434 33.3333 12.4821 33.3333 12.6222V35.3778Z'
      fill='black'
    />
    <path
      d='M18.0444 8H16.6222C15.3978 8.00468 14.2248 8.49317 13.359 9.35899C12.4932 10.2248 12.0047 11.3978 12 12.6222V35.3778C12.0047 36.6022 12.4932 37.7752 13.359 38.641C14.2248 39.5068 15.3978 39.9953 16.6222 40H18.0444C19.2689 39.9953 20.4419 39.5068 21.3077 38.641C22.1735 37.7752 22.662 36.6022 22.6667 35.3778V12.6222C22.662 11.3978 22.1735 10.2248 21.3077 9.35899C20.4419 8.49317 19.2689 8.00468 18.0444 8ZM19.1111 35.3778C19.1111 35.6607 18.9987 35.932 18.7987 36.132C18.5987 36.3321 18.3273 36.4444 18.0444 36.4444H16.6222C16.3393 36.4444 16.068 36.3321 15.868 36.132C15.6679 35.932 15.5556 35.6607 15.5556 35.3778V12.6222C15.5556 12.3393 15.6679 12.068 15.868 11.868C16.068 11.6679 16.3393 11.5556 16.6222 11.5556H18.0444C18.3273 11.5556 18.5987 11.6679 18.7987 11.868C18.9987 12.068 19.1111 12.3393 19.1111 12.6222V35.3778Z'
      fill='black'
    />
  </svg>
)

export default Pause
